/* eslint-disable array-callback-return */
import React, { useRef, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { GrClose } from "react-icons/gr";
import { reportSuggestion } from "../../Shared/validation";
import { report_suggestion } from "../../services/category.service";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import swal from "sweetalert";
import report_sugg_image from "../../assets/report_suggestion.svg";
import { LuImagePlus } from "react-icons/lu";

function ReportSuggestionModal({
  showReportModal,
  setShowReportModal,
  setRouteName,
  pointName,
  mkmID,
}) {
  const [errors, setErrors] = useState({});
  const fileRef = useRef();
  const [errorMsg, setErrorMsg] = useState(false);
  const [imageBase64, setImageBase64] = useState("");
  const [sendClick, setSendClick] = useState(false);
  const [values, setValues] = useState({
    title: "",
    description: "",
    routeName: pointName,
    image: [],
  });
  let filesUrls = [];

  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );

  const toggleReport = () => {
    // setShowReportModal((prev) => !prev);
    setShowReportModal(!showReportModal);
    setValues({
      title: "",
      description: "",
      routeName: pointName,
      image: [],
    });
    setErrors({});
    setErrorMsg("");
  };

  const handleChange = async (e) => {
    const { id, value } = e?.target;
    id === "title"
      ? setValues({
          ...values,
          [id]: value?.replace(/^\s+/, ""),
        })
      : setValues({
          ...values,
          [id]: value?.replace(/^\s+/, ""),
        });
    setErrors({
      ...errors,
      [id]: null,
    });
    if (e?.target?.files) {
      setErrorMsg("");
      Array.from(e?.target?.files).map((file) => {
        if (file?.size / 1000000 < 5) {
          file = URL.createObjectURL(file);
          filesUrls?.push(file);
        } else {
          setErrorMsg("File size should be less than 5 Mb");
        }
      });
      setValues({
        ...values,
        image: filesUrls,
      });
      // var img = [];

      for (let i = 0; i < e.target.files.length; i++) {
        var reader = new FileReader();

        var result = e.target.files[i];
        reader.readAsDataURL(result);

        reader.onload = (readerEvent) => {
          var img = readerEvent?.target?.result
            ?.replace("data:", "")
            .replace(/^.+,/, "");
          setImageBase64(img);
        };
        reader.onerror = (error) => {
          console.log("Error: ", error);
        };
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errorsx = await reportSuggestion(values);
    setErrors(errorsx);

    if (!errorsx) {
      setSendClick(true);
      try {
        let obj = {
          subject: values?.title?.trim(),
          pointType: 0,
          pointId: mkmID,
          description: values?.description?.trim(),
          image: imageBase64,
          userName: userName,
        };
        let response = await report_suggestion(obj);
        if (response && response?.status === 200) {
          toast.success(
            "Thank you for your efforts..!!, Your suggestion is reported to the Admin.",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "There was an error while sending the details, Please try again later",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
      }

      setValues({
        title: "",
        description: "",
        routeName: pointName,
        image: [],
      });
      setRouteName("");
      setShowReportModal(false);
      setSendClick(false);
    }
  };
  const CancelImage = async (index) => {
    const isDelete = await swal({
      title: "Are you sure?",
      text: "You are about to delete this photo",
      icon: "warning",
      buttons: ["Cancel", "Yes"],
    });
    if (isDelete) {
      values?.image?.splice(index, 1);
      filesUrls = values?.image;
      setValues({
        ...values,
        image: filesUrls,
      });
      swal("Deleted!", "Your route has been deleted!", "success");
    }
  };

  const renderPhotos = (source) => {
    return source?.map((photo) => {
      return (
        <div key={photo} className="privew_img">
          <img src={photo} alt="" width="64px" height="64px" />
          <Button type="button" onClick={(index) => CancelImage(index)}>
            <GrClose />
          </Button>
        </div>
      );
    });
  };

  const isDiasabled = () => {
    if (sendClick === true) {
      return true;
    }
  };

  return (
    <div>
      <Modal
        className="report_suggestion modal-dialog-centered"
        isOpen={showReportModal}
        toggle={toggleReport}
      >
        <ModalHeader>
          <img src={report_sugg_image} alt="loading" />
          <span>Report Suggestion</span>
        </ModalHeader>
        <ModalBody>
          <Form
            className="report_suggestion_form"
            encType="multipart/form-data"
          >
            <div className="form_title_heading">
              <div className="form-group-custom">
                <div className="form_lab">
                  <Label>Title:</Label>
                </div>
                <Input
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Title"
                  autoComplete="off"
                  value={values?.title}
                  onChange={handleChange}
                  maxLength="50"
                />
                <span className="error">{errors?.title && errors?.title}</span>
              </div>

              <div className="form-group-custom">
                <div className="form_lab">
                  <Label>Point Name:</Label>
                </div>
                <Input
                  type="text"
                  name="routeName"
                  id="routeName"
                  value={pointName}
                  placeholder="Point Name"
                  autoComplete="off"
                  disabled
                />
              </div>
            </div>

            <div className="form-group-custom">
              <div className="form_lab">
                <Label>Description:</Label>
              </div>
              <Input
                id="description"
                name="description"
                type="textarea"
                className="description"
                autoComplete="off"
                placeholder="Write your description here..."
                value={values?.description}
                onChange={handleChange}
                maxLength="256"
              />
              <span className="error">
                {errors?.description && errors?.description}
              </span>
            </div>

            <div className="form-group-custom">
              <div className="form_lab">
                <Label>Upload Image (Optional):</Label>
              </div>
              <div className="image_upload">
                {renderPhotos(values?.image)}
                <input
                  ref={fileRef}
                  onChange={handleChange}
                  name="image"
                  type="file"
                  accept="image/*"
                  hidden
                />
                <div className="button">
                  <Button
                    type="button"
                    onClick={() => fileRef?.current?.click()}
                    className="addPhoto"
                  >
                    <LuImagePlus size={40} />
                    Add Photos
                  </Button>
                </div>
              </div>
              <span className="error">{errorMsg}</span>
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button type="button" onClick={toggleReport}>
            Cancel
          </Button>
          <Button type="button" onClick={handleSubmit} disabled={isDiasabled()}>
            {sendClick === true ? <Spinner size="sm"></Spinner> : "Send"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ReportSuggestionModal;
